<template>
    <div id="ContainerEmployee">
        <h4 class="page-title text-truncate">
            {{ pageTitle }}
        </h4>

        <div class="page-height">
            <b-row>
                <b-col md="12" sm="12" lg="12">
                    <MdTabList
                        v-bind:TabList="tablist"
                        v-bind:ShowTabList="false"
                        v-bind:ShowTabEnd="false"
                    >
                        <div
                            class="tab-content tab-content-custom-pill"
                            id="pills-tabContent-custom"
                        >
                            <!----------------------------------------------------------------------- TAB General ---------------------------------------------------------------------->
                            <div class="tab-pane fade show active" id="general" role="tabpanel">
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.code"
                                            v-bind:Label="$t('Shared.Code')"
                                            v-bind:isReadOnly="this.$attrs.editMode"
                                            v-bind:isRequired="true"
                                            v-bind:MaxLengthProp="8"
                                            v-bind:isValid="isEmployeeValid"
                                            v-on:blur="OnCodeBlur(editableItem.code)"
                                            :InvalidFeedback="'Employee Code is Required'"
                                            :SearchFieldCode="'Code'"
                                            v-bind:Id="'input_e_code'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.Type')"
                                            v-bind:Options="typeList"
                                            v-bind:Model="editableItem.emptype"
                                            v-bind:FieldDescription="'description'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownType"
                                            :isRequired="true"
                                            :isValid="isEmployeeTypeValid"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.title"
                                            v-bind:Label="$t('Patient.Title')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="100"
                                            v-bind:Id="'input_e_t'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.employeeId"
                                            v-bind:Label="'Emp ID'"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_id'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.firstname"
                                            v-bind:Label="$t('Shared.FirstName')"
                                            v-bind:isRequired="true"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_fn'"
                                            :isValid="isEmployeeFirstNameValid"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.lastname"
                                            v-bind:Label="$t('Shared.LastName')"
                                            v-bind:isRequired="true"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_ln'"
                                            :isValid="isEmployeeLastNameValid"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.initial"
                                            v-bind:Label="$t('Shared.Initial')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="1"
                                            v-bind:Id="'input_e_ini'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.eMail"
                                            v-bind:Label="$t('Shared.Email')"
                                            v-bind:TypeProp="'email'"
                                            v-bind:isRequired="false"
                                            v-bind:isValid="this.emailValid"
                                            v-bind:MaxLengthProp="75"
                                            v-bind:Id="'input_e_email'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.address1"
                                            v-bind:Label="$t('Shared.Address1')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="30"
                                            v-bind:Id="'input_e_addrs1'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.address2"
                                            v-bind:Label="$t('Shared.Address2')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="30"
                                            v-bind:Id="'input_e_addrs2'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.zip"
                                            v-bind:Label="$t('Shared.Zip')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="10"
                                            v-bind:Id="'input_e_zip'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.city"
                                            v-bind:Label="$t('Shared.City')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="25"
                                            v-bind:Id="'input_e_city'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.state"
                                            v-bind:Label="$t('Shared.State')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="2"
                                            v-bind:Id="'input_e_state'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.county"
                                            v-bind:Label="$t('employee.County')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="25"
                                            v-bind:Id="'input_e_contry'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.country"
                                            v-bind:Label="$t('Shared.Country')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="25"
                                            v-bind:Id="'input_e_country'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.pool"
                                            v-bind:Label="$t('Patient.LegalFax')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_lf'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.dayphone"
                                            v-bind:Label="$t('Shared.DayPhone')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_dph'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.nightphone"
                                            v-bind:Label="$t('Shared.NightPhone')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_nph'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.beeper"
                                            v-bind:Label="$t('Shared.CellPhone')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_cph'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.license"
                                            v-bind:Label="$t('employee.DrivLic')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_licen'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('employee.phoneComp')"
                                            v-bind:Options="cellCompanyList"
                                            v-bind:Model="editableItem.cellCompany"
                                            v-bind:FieldDescription="'description'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownCellCompany"
                                            v-bind:Id="'input_e_comph'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.SSN')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:Name="'ssn'"
                                            v-bind:MaxLengthProp="10"
                                            v-model="editableItem.ssn"
                                            v-bind:Mask="'###-##-####'"
                                            v-bind:Id="'input_e_ssn'"
                                        >
                                        </MdEdit>
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdDateTime
                                            :Label="$t('Shared.Dob')"
                                            :Model="editableItem.dob"
                                            @input="editableItem.dob = $event"
                                            :Id="'EmployeeDob'"
                                            :Type="'date'"
                                            :isConfirm="false"
                                            :ReadOnly="false"
                                        >
                                        </MdDateTime>
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdRadioGroup
                                            v-bind:Label="$t('Shared.Gender')"
                                            v-model="editableItem.sex"
                                            v-bind:Options="GenderList"
                                            v-bind:Name="'Gender'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:ModelCode="editableItem.taxonomy"
                                            v-bind:ModelDescription="
                                                editableItem.taxonomyDescription
                                            "
                                            v-bind:Label="$t('Shared.Taxonomy')"
                                            v-bind:RefCode="'Taxonomy'"
                                            v-bind:Fields="BaseFieldsTaxonomy"
                                            v-bind:Api="'GlobalCodes?CodeType=TAXONOMY'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:IsDisabled="false"
                                            v-bind:FieldDescription="'description'"
                                            :SearchTitle="$t('Shared.Taxonomy')"
                                            :GetValues="onCodeConditionOk"
                                            :InvalidFeedback="$t('employee.InvTaxCodeMsg')"
                                            :SearchFieldCode="'Code'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.Ethnicity')"
                                            v-bind:Options="ethnicityList"
                                            v-bind:Model="editableItem.ethcode"
                                            v-bind:FieldDescription="'description'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownEthnicity"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:Label="$t('employee.UserID')"
                                            v-bind:ModelCode="editableItem.userid"
                                            v-bind:ModelDescription="editableItem.useridDescription"
                                            v-bind:RefCode="'UserIdCode'"
                                            v-bind:Fields="UserFields"
                                            v-bind:Api="'Users?Active=' + true"
                                            v-bind:FieldCode="'userCode'"
                                            v-bind:FieldDescription="'userName'"
                                            :SearchTitle="'Users'"
                                            :GetValues="onCodeConditionOk"
                                            :InvalidFeedback="'Invalid UserId'"
                                            :SearchFieldCode="'Code'"
                                            v-bind:IsDisabled="false"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('employee.Credentials')"
                                            v-bind:Options="credentialsList"
                                            v-bind:Model="editableItem.credentials"
                                            v-bind:FieldDescription="'description'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownCredentials"
                                        />
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.Status')"
                                            v-bind:Options="StatusList"
                                            v-bind:Model="editableItem.status"
                                            v-bind:FieldDescription="'text'"
                                            v-bind:FieldCode="'value'"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownStatus"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('MdNote.Cosigner')"
                                            v-bind:Options="CosignerList"
                                            v-bind:Model="editableItem.needCoSigner"
                                            v-bind:FieldDescription="'text'"
                                            v-bind:FieldCode="'value'"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownCosigner"
                                            :isRequired="true"
                                            :isValid="isNeedCosignerValid"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdDateTime
                                            :Label="$t('employee.HiredDate')"
                                            :Model="editableItem.hireddate"
                                            @input="editableItem.hireddate = $event"
                                            :Id="'EmployeeHiredDate'"
                                            :Type="'date'"
                                            :isConfirm="false"
                                            :ReadOnly="false"
                                        >
                                        </MdDateTime>
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdDateTime
                                            :Label="$t('employee.TerminateDate')"
                                            :Model="editableItem.terminatedate"
                                            @input="editableItem.terminatedate = $event"
                                            :Id="'EmployeeTerminateDate'"
                                            :Type="'date'"
                                            :isConfirm="false"
                                            :ReadOnly="isReadOnlyTerminateDate"
                                        >
                                        </MdDateTime>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('employee.CosInsAssig')"
                                            v-bind:Options="insuranceList"
                                            v-bind:Model="insuranceSelected"
                                            v-bind:FieldDescription="'description'"
                                            v-bind:FieldCode="'code'"
                                            :IsDisabled="isReadOnlyCosignerInsurance"
                                            v-bind:Multiple="true"
                                            :Input="ChangeDropDownCosignerInsurance"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.empProv"
                                            v-bind:Label="$t('employee.ProvNum')"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="9"
                                            v-bind:Id="'input_e_pro'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-model="editableItem.npi"
                                            v-bind:Label="'NPI'"
                                            v-bind:isRequired="false"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Id="'input_e_npi'"
                                        />
                                    </b-col>
                                    <b-col
                                        md="auto"
                                        lg="auto"
                                        sm="12"
                                        v-if="this.editableItem.emptype === 'D'"
                                    >
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.Driver')"
                                            v-bind:Name="'checkbox-Driver'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.isSelfDriver"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('PharmacyLocations.Location')"
                                            v-bind:Options="branchLocationList"
                                            v-bind:Model="editableItem.branchLocation"
                                            v-bind:FieldDescription="'description'"
                                            v-bind:FieldCode="'code'"
                                            :IsDisabled="false"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownBranchLocation"
                                        />
                                    </b-col>
                                </b-row>
                            </div>

                            <!-- BEGIN TAB DOCUMENT -->
                            <div class="tab-pane fade" id="document" role="tabpanel">
                                <b-row>
                                    <div class="col-sm-12 col-md-3">
                                        <MdButton
                                            v-bind:Label="$t('PatientDocument.AddDocument')"
                                            v-bind:ClassProp="
                                                isReadOnly
                                                    ? 'btn btn-primary my-3 btn-block'
                                                    : 'btn btn-primary my-3 btn-block btn-login'
                                            "
                                            v-bind:IconClass="'ti-plus pr-1'"
                                            v-on:click="CallModalDocument"
                                            v-bind:isReadOnly="this.isReadOnly"
                                        >
                                        </MdButton>
                                    </div>
                                    <div class="col-sm-12 col-md-9 mb-4">
                                        <div
                                            class="textlabel"
                                            :data-label="this.$t('Shared.SearchElements')"
                                        >
                                            <div class="input-group" dir="ltr">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :dir="dirInput"
                                                    v-model="searchDocument"
                                                    @keyup.enter="FindDocument"
                                                />
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="'btnsearchinputDocument'"
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="FindDocument"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <div class="row">
                                    <div class="col-md-12">
                                        <MdTablePaginationClient
                                            v-bind:FieldsDate="FieldsDateDocuments"
                                            v-bind:fields="fieldsDocuments"
                                            v-bind:items="documentCodesListFilter"
                                            v-bind:totalRows="totalRowsDocument"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:showMessageIsEmpty="showMessageIsEmptyDocuments"
                                            v-bind:currentPage="currentPageDocument"
                                            v-bind:perPage="perPageDocument"
                                            v-bind:pageOptions="pageOptionsDocument"
                                            v-bind:IsItemReceived="false"
                                            :onRowSelected="onRowSelectedDocument"
                                            :onFiltered="onFilteredDocument"
                                            :pageChanged="pageChangedDocument"
                                            :perPageFunction="PerPageFunctionDocument"
                                            :VisibleDeleteIcon="true"
                                            :deleteIconEvent="RemoveDocument"
                                            :VisibleEditIcon="true"
                                            :editIconEvent="EditDocument"
                                            :RowClick="RowClick"
                                        >
                                        </MdTablePaginationClient>
                                    </div>
                                </div>
                            </div>
                            <!-- END TAB DOCUMENT -->

                            <!-- BEGIN TAB DOCUMENT MANAGEMENT -->
                            <div class="tab-pane fade" id="docmgr" role="tabpanel">
                                <b-row>
                                    <div class="col-sm-12 col-md-3">
                                        <MdButton
                                            v-bind:Label="$t('PatientDocument.AddDocument')"
                                            v-bind:ClassProp="
                                                isReadOnly
                                                    ? 'btn btn-primary my-3 btn-block'
                                                    : 'btn btn-primary my-3 btn-block btn-login'
                                            "
                                            v-bind:IconClass="'ti-plus pr-1'"
                                            v-on:click="CallModalDocumentMgr"
                                            v-bind:isReadOnly="this.isReadOnly"
                                        >
                                        </MdButton>
                                    </div>
                                    <div class="col-sm-12 col-md-9 mb-4">
                                        <div
                                            class="textlabel"
                                            :data-label="this.$t('Shared.SearchElements')"
                                        >
                                            <div class="input-group" dir="ltr">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :dir="dirInput"
                                                    v-model="searchDocumentMgr"
                                                    @keyup.enter="FindDocumentMgr"
                                                />
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="'btnsearchinputDocument'"
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="FindDocumentMgr"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <div class="row">
                                    <div class="col-md-12">
                                        <MdTablePaginationClient
                                            v-bind:FieldsDate="FieldsDateDocumentMgr"
                                            v-bind:fields="fieldsDocumentMgr"
                                            v-bind:items="documentMgrCodesListFilter"
                                            v-bind:totalRows="totalRowsDocumentMgr"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:showMessageIsEmpty="
                                                showMessageIsEmptyDocumentMgr
                                            "
                                            v-bind:currentPage="currentPageDocumentMgr"
                                            v-bind:perPage="perPageDocumentMgr"
                                            v-bind:pageOptions="pageOptionsDocumentMgr"
                                            v-bind:IsItemReceived="false"
                                            :onRowSelected="onRowSelectedDocumentMgr"
                                            :onFiltered="onFilteredDocumentMgr"
                                            :pageChanged="pageChangedDocumentMgr"
                                            :perPageFunction="PerPageFunctionDocumentMgr"
                                            :VisibleDeleteIcon="true"
                                            :deleteIconEvent="RemoveDocumentMgr"
                                            :VisibleEditIcon="true"
                                            :editIconEvent="EditDocumentMgr"
                                            :RowClick="RowClick"
                                        >
                                        </MdTablePaginationClient>
                                    </div>
                                </div>
                            </div>
                            <!-- END TAB DOCUMENT MANAGEMENT -->

                            <!-- BEGIN TAB PROVIDER -->
                            <div class="tab-pane fade" id="providerid" role="tabpanel">
                                <providerPanel
                                    :insuranceList="insuranceList"
                                    :isReadOnly="isReadOnly"
                                    v-model="editableItem.providerCodesList"
                                >
                                </providerPanel>
                            </div>
                            <!-- END TAB PROVIDER -->

                            <!-- BEGIN TAB Signature -->
                            <div class="tab-pane fade" id="signaturecapture" role="tabpanel">
                                <b-row>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.CreateMedi')"
                                            v-bind:Name="'checkbox-CreateMedications'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigCreateMed"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('Shared.MARS')"
                                            v-bind:Name="'checkbox-Mars'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigMars"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.ReItems')"
                                            v-bind:Name="'checkbox-ReceivedItems'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigReceivedItems"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.Tars')"
                                            v-bind:Name="'checkbox-RequestSigTars'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigTars"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.FillOrders')"
                                            v-bind:Name="'checkbox-fillorders'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigFillOrders"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.UnFillOrders')"
                                            v-bind:Name="'checkbox-undofillorders'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigUndoFillOrders"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.ItemsRelocation')"
                                            v-bind:Name="'checkbox-RequestSigItemsRelocation'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigItemsRelocation"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.ReturnedItems')"
                                            v-bind:Name="'checkbox-RequestSigReturnItems'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigReturnItems"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.RemovedItems')"
                                            v-bind:Name="'checkbox-RequestSigRemoveItems'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigRemoveItems"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.CreateOrders')"
                                            v-bind:Name="'checkbox-RequestSigCreateORDERS'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requestSigCreateOrders"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('employee.TySign')"
                                            v-bind:Options="signaturePadList"
                                            v-bind:Model="editableItem.signaturePad"
                                            v-bind:FieldDescription="'description'"
                                            v-bind:FieldCode="'code'"
                                            :IsDisabled="false"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownTypeOfSignaturePad"
                                        />
                                    </b-col>
                                </b-row>

                                <b-row class="mt-2">
                                    <b-col md="5" lg="5" sm="12">
                                        <MdSignature
                                            v-bind:Title="$t('employee.SigEmpl')"
                                            v-bind:Id="'IdCanvasSignatureEmployee'"
                                            v-bind:Data64="editableItem.employeesignature"
                                            :OnlyData="false"
                                            :VisibleSigPad="visibleSigPad"
                                        />
                                    </b-col>
                                    <b-col md="5" lg="5" sm="12">
                                        <MdSignature
                                            v-bind:Title="$t('employee.empstamp')"
                                            v-bind:Id="'IdCanvasSignatureEmployeeempstamp'"
                                            v-bind:Data64="editableItem.employeestamp"
                                            :OnlyData="false"
                                            :VisibleSigPad="visibleSigPad"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- END TAB Signature -->

                            <!-- BEGIN TAB Restriction -->
                            <div class="tab-pane fade" id="restriction" role="tabpanel">
                                <MdTitle
                                    v-bind:StyleProp="'margin: 0em 0 0.7em 0'"
                                    v-bind:Text="$t('userHeader.EmployeeRestrictionLocation')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.EnforceSeleLoc')"
                                            v-bind:Name="'checkbox-LocationAfterLogin'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requiredLocation"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <div class="col-sm-12 col-md-3">
                                        <MdButton
                                            v-bind:Label="$t('Shared.AddBuilding')"
                                            v-bind:ClassProp="
                                                isReadOnly
                                                    ? 'btn btn-primary my-3 btn-block'
                                                    : 'btn btn-primary my-3 btn-block btn-login'
                                            "
                                            v-bind:IconClass="'ti-plus pr-1'"
                                            v-on:click="CallModalBuilding"
                                            v-bind:isReadOnly="this.isReadOnly"
                                        >
                                        </MdButton>
                                    </div>
                                    <div class="col-sm-12 col-md-9 mb-4">
                                        <div
                                            class="textlabel"
                                            :data-label="this.$t('Shared.SearchElements')"
                                        >
                                            <div class="input-group" dir="ltr">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :dir="dirInput"
                                                    v-model="searchBuilding"
                                                    @keyup.enter="FindBuilding"
                                                />
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="'btnsearchinputBuilding'"
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="FindBuilding"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <b-row>
                                    <div class="col-md-12">
                                        <MdTablePaginationClient
                                            v-bind:fields="fieldsBuilding"
                                            v-bind:items="buildingCodesListFilter"
                                            v-bind:totalRows="totalRowsBuilding"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:showMessageIsEmpty="showMessageIsEmptyBuildings"
                                            v-bind:currentPage="currentPageBuilding"
                                            v-bind:perPage="perPageBuilding"
                                            v-bind:pageOptions="pageOptionsBuilding"
                                            v-bind:IsItemReceived="false"
                                            :onRowSelected="onRowSelectedBuilding"
                                            :onFiltered="onFilteredBuilding"
                                            :pageChanged="pageChangedBuilding"
                                            :perPageFunction="PerPageFunctionBuilding"
                                            :VisibleDeleteIcon="true"
                                            :deleteIconEvent="RemoveBuilding"
                                            :RowClick="RowClick"
                                        >
                                        </MdTablePaginationClient>
                                    </div>
                                </b-row>

                                <MdTitle
                                    v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                    v-bind:Text="$t('userHeader.EmployeeRestrictionProgram')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.EnforceSeleProg')"
                                            v-bind:Name="
                                                'checkbox-RestrictPatientsshowingbyprogram'
                                            "
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.enforceSelectProgram"
                                        />
                                    </b-col>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="'Allow To Select'"
                                            v-bind:Options="AllowToSelectOptions"
                                            v-bind:Tag="'EmployeeAllowToSelect'"
                                            v-bind:FieldDescription="'text'"
                                            v-bind:FieldCode="'value'"
                                            v-bind:RequireEvent="true"
                                            v-bind:Model="editableItem.allowSelectMultProg"
                                            v-bind:Multiple="false"
                                            :Input="ChangeDropDownAllowToSelect"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <div class="col-sm-12 col-md-3 col-mb-3 col-lg-3">
                                        <MdButton
                                            v-bind:Label="$t('Shared.AddProgram')"
                                            v-bind:ClassProp="
                                                isReadOnly
                                                    ? 'btn btn-primary my-3 btn-block'
                                                    : 'btn btn-primary my-3 btn-block btn-login'
                                            "
                                            v-bind:IconClass="'ti-plus pr-1'"
                                            v-on:click="CallModalProgram"
                                            v-bind:isReadOnly="this.isReadOnly"
                                        >
                                        </MdButton>
                                    </div>
                                    <div class="col-sm-12 col-md-9 col-mb-9 col-lg-9">
                                        <div
                                            class="textlabel"
                                            :data-label="this.$t('Shared.SearchElements')"
                                        >
                                            <div class="input-group" dir="ltr">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :dir="dirInput"
                                                    v-model="searchProgram"
                                                    @keyup.enter="FindProgram"
                                                />
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="'btnsearchinputProgram'"
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="FindProgram"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <b-row>
                                    <div class="col-md-12">
                                        <MdTablePaginationClient
                                            v-bind:fields="fieldsProgram"
                                            v-bind:items="programCodesListFilter"
                                            v-bind:totalRows="totalRowsProgram"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:showMessageIsEmpty="showMessageIsEmptyPrograms"
                                            v-bind:currentPage="currentPageProgram"
                                            v-bind:perPage="perPageProgram"
                                            v-bind:pageOptions="pageOptionsProgram"
                                            v-bind:IsItemReceived="false"
                                            :onRowSelected="onRowSelectedProgram"
                                            :onFiltered="onFilteredProgram"
                                            :pageChanged="pageChangedProgram"
                                            :perPageFunction="PerPageFunctionProgram"
                                            :VisibleDeleteIcon="true"
                                            :deleteIconEvent="RemoveProgram"
                                            :RowClick="RowClick"
                                        >
                                        </MdTablePaginationClient>
                                    </div>
                                </b-row>

                                <MdTitle
                                    v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                    v-bind:Text="$t('userHeader.EmployeeRestrictionPharmacy')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col md="3" lg="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="
                                                'Enforce Selecting A Pharmacy After Login'
                                            "
                                            v-bind:Name="'checkbox-RestrictPharmacyLocation'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.requiredPharmacyLocation"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <div class="col-sm-12 col-md-3">
                                        <MdButton
                                            v-bind:Label="'Add Pharmacy'"
                                            v-bind:ClassProp="
                                                isReadOnly
                                                    ? 'btn btn-primary my-3 btn-block'
                                                    : 'btn btn-primary my-3 btn-block btn-login'
                                            "
                                            v-bind:IconClass="'ti-plus pr-1'"
                                            v-on:click="CallModalPharmacy"
                                            v-bind:isReadOnly="this.isReadOnly"
                                        >
                                        </MdButton>
                                    </div>
                                    <div class="col-sm-12 col-md-9 mb-4">
                                        <div
                                            class="textlabel"
                                            :data-label="this.$t('Shared.SearchElements')"
                                        >
                                            <div class="input-group" dir="ltr">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :dir="dirInput"
                                                    v-model="searchPharmacy"
                                                    @keyup.enter="FindPharmacy"
                                                />
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="'btnsearchinputPharmacy'"
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="FindPharmacy"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <b-row>
                                    <div class="col-md-12">
                                        <MdTablePaginationClient
                                            v-bind:fields="fieldsPharmacy"
                                            v-bind:items="pharmacyCodesListFilter"
                                            v-bind:totalRows="totalRowsPharmacy"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:showMessageIsEmpty="showMessageIsEmptyPharmacies"
                                            v-bind:currentPage="currentPagePharmacy"
                                            v-bind:perPage="perPagePharmacy"
                                            v-bind:pageOptions="pageOptionsPharmacy"
                                            v-bind:IsItemReceived="false"
                                            :onRowSelected="onRowSelectedPharmacy"
                                            :onFiltered="onFilteredPharmacy"
                                            :pageChanged="pageChangedPharmacy"
                                            :perPageFunction="PerPageFunctionPharmacy"
                                            :VisibleDeleteIcon="true"
                                            :deleteIconEvent="RemovePharmacy"
                                            :RowClick="RowClick"
                                        >
                                        </MdTablePaginationClient>
                                    </div>
                                </b-row>

                                <MdTitle
                                    v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                    v-bind:Text="
                                        $t('userHeader.EmployeeRestrictionPharmacyRemoval')
                                    "
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <div class="col-sm-12 col-md-3">
                                        <MdButton
                                            v-bind:Label="'Add Pharmacy'"
                                            v-bind:ClassProp="
                                                isReadOnly
                                                    ? 'btn btn-primary my-3 btn-block'
                                                    : 'btn btn-primary my-3 btn-block btn-login'
                                            "
                                            v-bind:IconClass="'ti-plus pr-1'"
                                            v-on:click="CallModalPharmacyRemoval"
                                            v-bind:isReadOnly="this.isReadOnly"
                                        >
                                        </MdButton>
                                    </div>
                                    <div class="col-sm-12 col-md-9 mb-4">
                                        <div
                                            class="textlabel"
                                            :data-label="this.$t('Shared.SearchElements')"
                                        >
                                            <div class="input-group" dir="ltr">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :dir="dirInput"
                                                    v-model="searchPharmacyRemoval"
                                                    @keyup.enter="FindPharmacyRemoval"
                                                />
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="
                                                                'btnsearchinputPharmacyRemoval'
                                                            "
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="FindPharmacyRemoval"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <b-row>
                                    <div class="col-md-12">
                                        <MdTablePaginationClient
                                            v-bind:fields="fieldsPharmacyRemoval"
                                            v-bind:items="pharmacyRemovalCodesListFilter"
                                            v-bind:totalRows="totalRowsPharmacyRemoval"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:showMessageIsEmpty="
                                                showMessageIsEmptyPharmaciesRemoval
                                            "
                                            v-bind:currentPage="currentPagePharmacyRemoval"
                                            v-bind:perPage="perPagePharmacyRemoval"
                                            v-bind:pageOptions="pageOptionsPharmacyRemoval"
                                            v-bind:IsItemReceived="false"
                                            :onRowSelected="onRowSelectedPharmacyRemoval"
                                            :onFiltered="onFilteredPharmacyRemoval"
                                            :pageChanged="pageChangedPharmacyRemoval"
                                            :perPageFunction="PerPageFunctionPharmacyRemoval"
                                            :VisibleDeleteIcon="true"
                                            :deleteIconEvent="RemovePharmacyRemoval"
                                            :RowClick="RowClick"
                                        >
                                        </MdTablePaginationClient>
                                    </div>
                                </b-row>

                                <MdTitle
                                    v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                    v-bind:Text="$t('userHeader.EmployeeRestrictionScheduler')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="'Days Before The Appointment'"
                                            v-bind:Name="'EmployeeDaysBeforeTheAppointment'"
                                            v-bind:TypeProp="'number'"
                                            v-model.number="editableItem.daysBeforeAppt"
                                            v-bind:isReadOnly="false"
                                            v-bind:Id="'input__EmployeeDaysBeforeTheAppointment'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="'Days After The Appointment'"
                                            v-bind:Name="'EmployeeDaysAfterTheAppointment'"
                                            v-bind:TypeProp="'number'"
                                            v-model.number="editableItem.daysAfterAppt"
                                            v-bind:isReadOnly="false"
                                            v-bind:Id="'input__EmployeeDaysAfterTheAppointment'"
                                        />
                                    </b-col>
                                    <b-col md="5" lg="5" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('employee.ShowOnly')"
                                            v-bind:Name="
                                                'checkbox-ShowOnlyPatientsAssignedInTheScheduler'
                                            "
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="editableItem.showOnlyPatientFromScheduler"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- END TAB Restriction -->
                        </div>
                    </MdTabList>
                </b-col>
            </b-row>

            <div class="space-actions"></div>
            <div class="page-actions">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btnbtn_save_Employeelist'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"
                />
                <MdButton
                    v-bind:Label="$t('Shared.Save')"
                    v-bind:ClassProp="this.isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                    v-on:click="SaveOrEdit"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Name="'btn_save_Employee'"
                />
            </div>
        </div>

        <EmployeeDocumentModal
            :visible.sync="visibleDocumentModal"
            v-model="editableDocument"
            :documentTypeList="documentTypeList"
            :editMode="editableItemMode"
            @ok="saveDocument"
        >
        </EmployeeDocumentModal>

        <EmployeeDocumentMgrModal
            :visible.sync="visibleDocumentMgrModal"
            v-model="editableDocumentMgr"
            :documentTypeList="documentTypeList"
            :editMode="editableItemMode"
            @ok="saveDocumentMgr"
        >
        </EmployeeDocumentMgrModal>

        <ModalTablePaginationServer
            v-bind:Resource="BuildingApiCall"
            v-bind:TypeOption="'Building'"
            @getCodeConditionOK="onCodeConditionOk($event)"
            v-bind:Fields="this.BaseFieldsBuilding"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('Shared.AddBuilding')"
            v-bind:ModalId="BuildingDlgId"
        >
        </ModalTablePaginationServer>

        <ModalTablePaginationServer
            v-bind:Resource="ProgramApiCall"
            v-bind:TypeOption="'Program'"
            @getCodeConditionOK="onCodeConditionOk($event)"
            v-bind:Fields="this.BaseFieldsProgram"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('Shared.AddProgram')"
            v-bind:ModalId="ProgramDlgId"
        >
        </ModalTablePaginationServer>

        <ModalTablePaginationServer
            v-bind:Resource="PharmacyApiCall"
            v-bind:TypeOption="PharmacyModalType"
            @getCodeConditionOK="onCodeConditionOk($event)"
            v-bind:Fields="this.BaseFieldsPharmacy"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('userHeader.EmployeePharmacyTitle')"
            v-bind:ModalId="PharmacyDlgId"
        >
        </ModalTablePaginationServer>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import EmployeeService from '@/services/employee.service';
import EnumService from '@/services/enum.service';
import GlobalService from '@/services/global.service';
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission';
import EmployeeTypesService from '@/services/employeetypes.service';
import BranchLocation from '@/services/branchlocation.service';
import EmployeeCredentialService from '@/services/employeecredential.service';
import RaceService from '@/services/race.service';
import EmployeeDocumentModal from '@/components/pages/setup/users/employee_doctor/employeeDocumentModal.vue';
import EmployeeDocumentMgrModal from '@/components/pages/setup/users/employee_doctor/employeeDocumentMgrModal.vue';
import ProviderPanel from '@/components/pages/setup/users/employee_doctor/providerPanel.vue';
import validator from 'validator';
import InsuranceService from '@/services/insurance.service';
import DocumentTypeService from '@/services/documenttype.service';

let elemSaveBtn = '';
export default {
    name: 'Employee',
    mixins: [ShowMessage, DBFunctions, Utils, Permission /*,EventBus*/],
    components: {
        EmployeeDocumentModal,
        EmployeeDocumentMgrModal,
        ProviderPanel
    },

    computed: {
        pageTitle() {
            return this.$attrs.editMode ? this.$t('employee.Edit') : this.$t('employee.Add');
        },

        visibleSigPad() {
            return !!this.editableItem.signaturePad?.length;
        },

        insuranceSelected() {
            const items = this.editableItem.insuranceList?.split(',') || [];
            return this.insuranceList.filter(value => items.some(v => v === value.code));
        },

        isReadOnlyCosignerInsurance() {
            return this.editableItem.needCoSigner !== 'Y';
        },

        isReadOnlyTerminateDate() {
            return this.editableItem.status !== 'T';
        },

        documentCodesListFilter() {
            const search = (this.search.document || '').trim().toLowerCase();
            const list = this.editableItem.documentCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.documentName || '').toLowerCase();
                const id = (item.comment || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        documentMgrCodesListFilter() {
            const search = (this.search.documentMgr || '').trim().toLowerCase();
            const list = this.editableItem.documentMgrCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.documentName || '').toLowerCase();
                const id = (item.comment || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        buildingCodesListFilter() {
            const search = (this.search.building || '').trim().toLowerCase();
            const list = this.editableItem.buildingCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.buildingName || '').toLowerCase();
                const id = (item.buildingCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        programCodesListFilter() {
            const search = (this.search.program || '').trim().toLowerCase();
            const list = this.editableItem.programCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.programName || '').toLowerCase();
                const id = (item.programCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        pharmacyCodesListFilter() {
            const search = (this.search.pharmacy || '').trim().toLowerCase();
            const list = this.editableItem.pharmacyCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.pharmacyName || '').toLowerCase();
                const id = (item.pharmacyCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        pharmacyRemovalCodesListFilter() {
            const search = (this.search.pharmacyRemoval || '').trim().toLowerCase();
            const list = this.editableItem.pharmacyRemovalCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.pharmacyName || '').toLowerCase();
                const id = (item.pharmacyCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        totalRowsDocument() {
            return this.documentCodesListFilter.length;
        },

        totalRowsDocumentMgr() {
            return this.documentMgrCodesListFilter.length;
        },

        totalRowsBuilding() {
            return this.buildingCodesListFilter.length;
        },

        totalRowsProgram() {
            return this.programCodesListFilter.length;
        },

        totalRowsPharmacy() {
            return this.pharmacyCodesListFilter.length;
        },

        totalRowsPharmacyRemoval() {
            return this.pharmacyRemovalCodesListFilter.length;
        },

        showMessageIsEmptyDocuments() {
            return this.totalRowsDocument === 0;
        },

        showMessageIsEmptyDocumentMgr() {
            return this.totalRowsDocument === 0;
        },

        showMessageIsEmptyBuildings() {
            return this.totalRowsBuilding === 0;
        },

        showMessageIsEmptyPharmacies() {
            return this.totalRowsPharmacy === 0;
        },

        showMessageIsEmptyPharmaciesRemoval() {
            return this.totalRowsPharmacyRemoval === 0;
        },

        showMessageIsEmptyPrograms() {
            return this.totalRowsProgram === 0;
        }
    },

    data() {
        const defaultEmployeeProps = {
            code: '',
            description: '',
            credentials: '',
            firstname: '',
            lastname: '',
            license: '',
            initial: '',
            dayPhone: '',
            nightphone: '',
            address1: '',
            address2: '',
            zip: '',
            beeper: '',
            city: '',
            title: '',
            state: '',
            empProv: '',
            ethcode: '',
            country: '',
            eMail: '',
            status: '',
            county: '',
            pool: '',
            ssn: '',
            textAddress: '',
            needCoSigner: 'N',
            hireddate: null,
            signaturePad: '',
            dob: null,
            sex: '',
            taxonomy: '',
            taxonomyDescription: '',
            cellCompany: '',
            userid: '',
            useridDescription: '',
            branchLocation: '',
            employeeId: '',
            webFormatStamp: '',
            emptype: '',
            terminatedate: null,
            emp_Prov: '',
            employeestamp: '',
            employeestampExt: '',
            npi: '',
            newCropUserType: '',
            employeesignature: '',
            employeesignatureExt: '',
            daysBeforeAppt: 0,
            daysAfterAppt: 0,
            webFormatSignature: '',
            requiredLocation: false,
            allowSelectMultProg: false,
            selectConsInsurances: false,
            insuranceList: null,
            enforceSelectProgram: false,
            showOnlyPatientFromScheduler: false,
            isSelfDriver: false,
            requestSigCreateMed: false,
            requiredPharmacyLocation: false,
            requestSigMars: false,
            requestSigReceivedItems: false,
            requestSigFillOrders: false,
            requestSigUndoFillOrders: false,
            requestSigItemsRelocation: false,
            requestSigCreateCpoe: false,
            requestSigReturnItems: false,
            requestSigRemoveItems: false,
            requestSigCreateOrders: false,
            requestSigTars: false,

            buildingCodesList: [],
            programCodesList: [],
            pharmacyCodesList: [],
            pharmacyRemovalCodesList: [],
            providerCodesList: [],
            documentCodesList: [],
            documentMgrCodesList: []
        };

        return {
            isReadOnly: false,
            parameter: {
                SearchCriteria: '',
                PageNumber: 1,
                PageSize: 0
            },
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            defaultEmployeeProps: defaultEmployeeProps,
            editableItem: defaultEmployeeProps,
            tablist: [
                { title: this.$t('Shared.General'), link: '#general', active: true },
                { title: this.$t('employee.Document'), link: '#document' },
                { title: this.$t('employee.DocumentMgr'), link: '#docmgr' },
                { title: this.$t('Shared.ProviderId'), link: '#providerid' },
                { title: this.$t('employee.SigCapture'), link: '#signaturecapture' },
                { title: this.$t('employee.Restriction'), link: '#restriction' }
            ],
            BaseFieldsTaxonomy: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') }
            ],
            StatusList: EnumService.EmployeeStatus,
            CosignerList: EnumService.CosignerList,
            FieldsDateDocuments: ['expDate'],
            FieldsDateDocumentMgr: ['scanneddate', 'expiration'],
            fieldsDocuments: [
                {
                    key: 'documentName',
                    sortable: true,
                    label: this.$t('employee.Document'),
                    class: 'text-rigth'
                },
                {
                    key: 'expDate',
                    sortable: true,
                    label: this.$t('employee.TerminateDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'comment',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-rigth'
                }
            ],
            fieldsDocumentMgr: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('PatientDocument.DocumentType'),
                    class: 'text-rigth'
                },
                {
                    key: 'scanneddate',
                    sortable: true,
                    label: this.$t('HouseFile.FileDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'expirationDate',
                    sortable: true,
                    label: this.$t('Shared.ExpirationDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'comments',
                    sortable: true,
                    label: this.$t('Shared.Comments'),
                    class: 'text-rigth'
                },
                {
                    key: 'fileName',
                    sortable: true,
                    label: this.$t('HouseFile.FileName'),
                    class: 'text-rigth'
                }
            ],
            fieldsBuilding: [
                {
                    key: 'buildingCode',
                    sortable: true,
                    label: this.$t('employee.BuilCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'buildingName',
                    sortable: true,
                    label: this.$t('Shared.BuildingName'),
                    class: 'text-rigth'
                }
            ],
            BaseFieldsBuilding: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('employee.BuilCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'name',
                    sortable: true,
                    label: this.$t('Shared.BuildingName'),
                    class: 'text-rigth'
                }
            ],
            fieldsProgram: [
                {
                    key: 'programCode',
                    sortable: true,
                    label: this.$t('Shared.ProgramCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'programName',
                    sortable: true,
                    label: this.$tc('Shared.ProgramName'),
                    class: 'text-rigth'
                }
            ],
            BaseFieldsProgram: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.ProgramCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'name',
                    sortable: true,
                    label: this.$tc('Shared.ProgramName'),
                    class: 'text-rigth'
                }
            ],
            fieldsPharmacy: [
                {
                    key: 'pharmacyCode',
                    sortable: true,
                    label: this.$t('Shared.PharmacyCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'pharmacyName',
                    sortable: true,
                    label: this.$tc('Shared.PharmacyName'),
                    class: 'text-rigth'
                }
            ],
            fieldsPharmacyRemoval: [
                {
                    key: 'pharmacyCode',
                    sortable: true,
                    label: this.$t('Shared.PharmacyCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'pharmacyName',
                    sortable: true,
                    label: this.$tc('Shared.PharmacyName'),
                    class: 'text-rigth'
                }
            ],
            BaseFieldsPharmacy: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.PharmacyCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'name',
                    sortable: true,
                    label: this.$tc('Shared.PharmacyName'),
                    class: 'text-rigth'
                }
            ],
            UserFields: [
                { key: 'userName', sortable: true, label: this.$t('Shared.UserName') },
                { key: 'userCode', sortable: true, label: this.$t('doctor.UserCode') }
            ],
            AllowToSelectOptions: EnumService.EmployeeProgramType,
            GenderList: EnumService.SexsMaleFemaleOnly,
            search: {
                provider: '',
                document: '',
                documentMgr: '',
                building: '',
                program: '',
                pharmacy: '',
                pharmacyRemoval: ''
            },
            searchDocument: '',
            searchDocumentMgr: '',
            searchBuilding: '',
            searchProgram: '',
            searchPharmacy: '',
            searchPharmacyRemoval: '',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            currentPageDocument: 1,
            currentPageDocumentMgr: 1,
            currentPageBuilding: 1,
            currentPageProgram: 1,
            currentPagePharmacy: 1,
            currentPagePharmacyRemoval: 1,
            perPageDocument: 10,
            perPageDocumentMgr: 10,
            perPageBuilding: 10,
            perPageProgram: 10,
            perPagePharmacy: 10,
            perPagePharmacyRemoval: 10,
            pageOptionsDocument: [5, 10, 15],
            pageOptionsDocumentMgr: [5, 10, 15],
            pageOptionsBuilding: [5, 10, 15],
            pageOptionsProgram: [5, 10, 15],
            pageOptionsPharmacyRemoval: [5, 10, 15],
            pageOptionsPharmacy: [5, 10, 15],
            isValidDob: true,
            isValidHiredDate: true,
            isValidTerminateDate: true,
            visibleProviderModal: false,
            visibleDocumentModal: false,
            visibleDocumentMgrModal: false,
            visibleBuildingModal: false,
            editableDocument: {
                employeeCode: '',
                docCode: '',
                recNo: null,
                comment: '',
                expDate: null,
                documentName: ''
            },
            editableDocumentMgr: {
                comments: '',
                description: '',
                doccode: '',
                entitycode: '',
                entitytype: '',
                expirationDate: null,
                extension: '',
                fileName: '',
                sysUser: null,
                IsNew: false,
                Image: ''
            },
            editableBuilding: {
                employeeCode: '',
                buildingCode: '',
                buildingName: ''
            },
            editableProgram: {
                employeeCode: '',
                programCode: '',
                programName: ''
            },
            editablePharmacy: {
                employeeCode: '',
                pharmacyCode: '',
                pharmacyName: ''
            },
            editablePharmacyRemoval: {
                employeeCode: '',
                pharmacyCode: '',
                pharmacyName: ''
            },
            editableItemMode: false,
            BuildingApiCall: 'Buildings?active=true',
            ProgramApiCall: 'Programs',
            PharmacyApiCall: 'PharmacyLocations',
            BuildingDlgId: 'BuildingModalId',
            ProgramDlgId: 'ProgramModalId',
            PharmacyDlgId: 'PharmacyModalId',
            PharmacyModalType: 'Pharmacy',
            isEmployeeTypeValid: true,
            isNeedCosignerValid: true,
            isEmployeeValid: true,
            emailValid: true,
            cellCompanyList: [],
            ethnicityList: [],
            credentialsList: [],
            insuranceList: [],
            typeList: [],
            branchLocationList: [],
            documentTypeList: [],
            signaturePadList: [],
            loaded: !this.$attrs.editMode,
            isEmployeeFirstNameValid: true,
            isEmployeeLastNameValid: true,
            pendingChanges: false
        };
    },

    methods: {
        DiscardChanges() {
            this.checkExistFavorite('/app/employees');
            this.$router.push({ name: 'employeeList' });
        },

        ChangeDropDownAllowToSelect(value) {
            this.editableItem.allowSelectMultProg = value ? value.value : '';
        },

        ChangeDropDownBranchLocation(value) {
            this.editableItem.branchLocation = value ? value.code : '';
        },

        ChangeDropDownTypeOfSignaturePad(value) {
            this.editableItem.signaturePad = value ? value.code : '';
        },

        ChangeDropDownCosigner(value) {
            this.editableItem.needCoSigner = value ? value.value : '';
            this.editableItem.selectConsInsurances = !this.isReadOnlyCosignerInsurance;
            if (this.isReadOnlyCosignerInsurance) {
                this.editableItem.insuranceList = null;
            }
        },

        ChangeDropDownCosignerInsurance(value) {
            this.editableItem.insuranceList = value ? value.map(v => v.code).join(',') : null;
            this.editableItem.selectConsInsurances = true;
        },

        async getCredential() {
            await EmployeeCredentialService.getEmployeeCredential()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.credentialsList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getBranchLocation() {
            await BranchLocation.GetBranchLocations()
                .then(response => {
                    if (response.status == '200') {
                        this.branchLocationList = [
                            { code: '<ALL>', description: '<ALL>' },
                            ...response.data
                        ];
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getRaces() {
            await RaceService.getAll()
                .then(response => {
                    if (response.status == '200') {
                        this.ethnicityList = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        ChangeDropDownStatus(e) {
            this.editableItem.status = e ? e.value : '';
            if (this.isReadOnlyTerminateDate) {
                this.editableItem.terminatedate = null;
            }
        },

        ChangeDropDownCredentials(value) {
            this.editableItem.credentials = value ? value.code : '';
        },

        ChangeDropDownEthnicity(value) {
            this.editableItem.ethcode = value ? value.code : '';
        },

        ChangeDropDownType(item) {
            this.editableItem.emptype = item ? item.code : '';

            if (this.editableItem.emptype !== 'D') {
                this.editableItem.isSelfDriver = false;
            }
        },

        ChangeDropDownCellCompany(value) {
            this.editableItem.cellCompany = value ? value.code : '';
        },

        RowClick() {},

        async getDefaultDateTime() {
            await GlobalService.getDateTime()
                .then(response => {
                    if (response.data) {
                        this.editableItem.hireddate = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('Building') >= 0) {
                this.$bvModal.hide(this.BuildingDlgId);
                if (result.code) {
                    const buildingCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.buildingCodesList.findIndex(item => {
                        const code = (item.buildingCode || '').toLowerCase();

                        return buildingCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.buildingCodesList.push({
                            buildingCode: buildingCode,
                            buildingName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('building');
                    }
                }
            } else if (type.indexOf('Program') >= 0) {
                this.$bvModal.hide(this.ProgramDlgId);
                if (result.code) {
                    const programCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.programCodesList.findIndex(item => {
                        const code = (item.programCode || '').toLowerCase();

                        return programCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.programCodesList.push({
                            programCode: programCode,
                            programName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('program');
                    }
                }
            } else if (type.indexOf('Pharmacy') >= 0) {
                this.$bvModal.hide(this.PharmacyDlgId);
                if (result.code) {
                    const pharmacyCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.pharmacyCodesList.findIndex(item => {
                        const code = (item.pharmacyCode || '').toLowerCase();

                        return pharmacyCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.pharmacyCodesList.push({
                            pharmacyCode: pharmacyCode,
                            pharmacyName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('pharmacy');
                    }
                }
            } else if (type.indexOf('Removal') >= 0) {
                this.$bvModal.hide(this.PharmacyDlgId);
                if (result.code) {
                    const pharmacyCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.pharmacyRemovalCodesList.findIndex(item => {
                        const code = (item.pharmacyCode || '').toLowerCase();

                        return pharmacyCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.pharmacyRemovalCodesList.push({
                            pharmacyCode: pharmacyCode,
                            pharmacyName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('pharmacyRemoval');
                    }
                }
            } else if (type.indexOf('Taxonomy') >= 0) {
                this.editableItem.taxonomy = result ? result.code : '';
                this.editableItem.taxonomyDescription = result ? result.description : '';
            } else if (type.indexOf('UserIdCode') >= 0) {
                this.editableItem.userid = result ? result.code : '';
                this.editableItem.useridDescription = result ? result.description : '';
            }
        },

        AddEmployee() {
            if (!this.CodeExist) {
                const data = this.PrepareData();
                EmployeeService.Add(data)
                    .then(response => {
                        if (response.status == '200') {
                            this.editableItem = response.data;
                            this.pendingChanges = false;
                            this.$router.push({ name: 'employeeList' }).catch(() => {});
                            setTimeout(
                                () =>
                                    this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                        title: this.$t('Msg.Success'),
                                        autoHideDelay: 5000,
                                        variant: 'success'
                                    }),
                                50
                            );
                        }
                    })
                    .catch(error => {
                        elemSaveBtn.removeAttribute('disabled');
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('employee.EmplCodeExist'), 'error');
            }
        },

        OnCodeBlur(value) {
            if (!this.$attrs.editMode) {
                if (value.trim() !== '') {
                    var parameter = {
                        code: value
                    };
                    EmployeeService.getEmployeeByCode(parameter)
                        .then(response => {
                            if (response.status == '200' && response.data) {
                                if (response.data.length > 0) {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        this.$t('employee.EmplCodeExist'),
                                        'error'
                                    );
                                    this.CodeExist = true;
                                } else {
                                    this.CodeExist = false;
                                }
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
                }
            }
        },

        EditEmployee() {
            const data = this.PrepareData();
            EmployeeService.Update(this.$route.params.id, data)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.$router.push({ name: 'employeeList' }).catch(() => {});
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$tc('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        async getEmployee() {
            if (this.$attrs.editMode) {
                await EmployeeService.Get(this.$route.params.id)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            const employeeData = response.data;
                            employeeData.allowSelectMultProg =
                                employeeData.allowSelectMultProg === null
                                    ? ''
                                    : employeeData.allowSelectMultProg
                                    ? 'Y'
                                    : 'N';
                            employeeData.documentMgrCodesList = employeeData.documentMgrCodesList.map(
                                document => ({
                                    IsNew: false,
                                    Image: Utils.getType(document.extension),
                                    comments: document.comments,
                                    description: document.description,
                                    doccode: document.doccode,
                                    entitycode: document.entitycode,
                                    entitytype: document.entitytype,
                                    expirationDate: document.expirationDateDocument,
                                    extension: document.extension,
                                    fileName: document.fileName,
                                    sysUser: document.sysUser,
                                    scanneddate: document.scanneddate,
                                    contents: document.contents,
                                    seqno: document.seqno
                                })
                            );

                            this.editableItem = employeeData;
                            this.loaded = true;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        async getCellPhoneCompany() {
            let param = {
                CodeType: 'CarrierList',
                OrderBy: 'SeqNo'
            };
            await GlobalService.getGlobalCustom(param)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.cellCompanyList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getEmployeeTypes() {
            const param = {
                Active: true
            };
            this.typeList = [];
            await EmployeeTypesService.getAllEmployeeType(param)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.typeList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        PrepareData() {
            const employeeCode = this.editableItem.code;
            const allowSelectMultProg = Utils.isNullOrEmptyString(
                this.editableItem.allowSelectMultProg
            )
                ? null
                : this.editableItem.allowSelectMultProg === 'Y'
                ? true
                : false;

            return {
                userid: this.editableItem.userid,
                code: employeeCode,
                address1: this.editableItem.address1,
                address2: this.editableItem.address2,
                city: this.editableItem.city,
                country: this.editableItem.country,
                firstname: this.editableItem.firstname,
                initial: this.editableItem.initial,
                lastname: this.editableItem.lastname,
                phone: this.editableItem.phone,
                state: this.editableItem.state,
                zip: this.editableItem.zip,
                eMail: this.editableItem.eMail,
                county: this.editableItem.county,
                beeper: this.editableItem.beeper,
                credentials: this.editableItem.credentials,
                dayphone: this.editableItem.dayphone,
                dob: this.editableItem.dob,
                employeesignature: this.editableItem.employeesignature,
                employeesignatureExt: this.editableItem.employeesignatureExt,
                emptype: this.editableItem.emptype,
                empProv: this.editableItem.empProv,
                ethcode: this.editableItem.ethcode,
                hireddate: this.editableItem.hireddate,
                isSelfDriver: this.editableItem.isSelfDriver,
                license: this.editableItem.license,
                nightphone: this.editableItem.nightphone,
                pool: this.editableItem.pool,
                sex: this.editableItem.sex,
                ssn: this.editableItem.ssn,
                status: this.editableItem.status,
                terminatedate: this.editableItem.terminatedate,
                npi: this.editableItem.npi,
                taxonomy: this.editableItem.taxonomy,
                cellCompany: this.editableItem.cellCompany,
                textAddress: this.editableItem.textAddress, //VERIFY
                needCoSigner: this.editableItem.needCoSigner,
                requiredLocation: this.editableItem.requiredLocation,
                requestSigCreateMed: this.editableItem.requestSigCreateMed,
                requestSigMars: this.editableItem.requestSigMars,
                title: this.editableItem.title,
                requestSigReceivedItems: this.editableItem.requestSigReceivedItems,
                requestSigFillOrders: this.editableItem.requestSigFillOrders,
                requestSigItemsRelocation: this.editableItem.requestSigItemsRelocation,
                requestSigReturnItems: this.editableItem.requestSigReturnItems,
                requestSigUndoFillOrders: this.editableItem.requestSigUndoFillOrders,
                requestSigRemoveItems: this.editableItem.requestSigRemoveItems,
                signaturePad: this.editableItem.signaturePad,
                requestSigCreateOrders: this.editableItem.requestSigCreateOrders,
                requestSigTars: this.editableItem.requestSigTars,
                showOnlyPatientFromScheduler: this.editableItem.showOnlyPatientFromScheduler,
                daysBeforeAppt: this.editableItem.daysBeforeAppt,
                daysAfterAppt: this.editableItem.daysAfterAppt,
                enforceSelectProgram: this.editableItem.enforceSelectProgram,
                allowSelectMultProg: allowSelectMultProg,
                selectConsInsurances: this.editableItem.selectConsInsurances, //VErify
                insuranceList: this.editableItem.insuranceList,
                webFormatSignature: this.editableItem.webFormatSignature, //verify
                branchLocation: this.editableItem.branchLocation,
                requiredPharmacyLocation: this.editableItem.requiredPharmacyLocation,
                newCropUserType: this.editableItem.newCropUserType, //verify
                employeestamp: this.editableItem.employeestamp,
                employeestampExt: this.editableItem.employeestampExt,
                webFormatStamp: this.editableItem.webFormatStamp, //verify
                employeeId: this.editableItem.employeeId,
                buildingCodesList: this.editableItem.buildingCodesList.map(item => ({
                    employeeCode: employeeCode,
                    buildingCode: item.buildingCode
                })),
                programCodesList: this.editableItem.programCodesList.map(item => ({
                    employeeCode: employeeCode,
                    programCode: item.programCode
                })),
                pharmacyCodesList: this.editableItem.pharmacyCodesList.map(item => ({
                    employeeCode: employeeCode,
                    pharmacyCode: item.pharmacyCode
                })),
                pharmacyRemovalCodesList: this.editableItem.pharmacyRemovalCodesList.map(item => ({
                    employeeCode: employeeCode,
                    pharmacyCode: item.pharmacyCode
                })),
                providerCodesList: this.editableItem.providerCodesList.map(item => ({
                    code: employeeCode,
                    providerId: item.providerId,
                    insuranceCode: item.insuranceCode
                })),
                documentCodesList: this.editableItem.documentCodesList.map(item => ({
                    employeeCode: employeeCode,
                    docCode: item.docCode,
                    recNo: item.recNo,
                    comment: item.comment,
                    expDate: item.expDate
                })),
                documentMgrCodesList: this.editableItem.documentMgrCodesList.map(item => ({
                    ...item,
                    entitycode: employeeCode
                }))
            };
        },

        DoAction() {
            !this.$attrs.editMode ? this.AddEmployee() : this.EditEmployee();
        },

        SaveOrEdit() {
            if (this.validate_entries()) {
                if (this.validate_required()) {
                    this.DoAction();
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.CheckRedLabeledFields'),
                        'errorAutoHide'
                    );
                }
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.InvalidFieldValuesDetected'),
                    'errorAutoHide'
                );
            }
        },

        validate_required() {
            /*this.isEmployeeValid = this.editableItem.code.length > 0 ? true : false;
            return this.isEmployeeValid;*/
            this.isValidDob =
                Utils.isNullOrEmptyString(this.editableItem.dob) ||
                (Utils.validateBirthDate(this.editableItem.dob) ? true : false);
            this.isValidHiredDate =
                Utils.isNullOrEmptyString(this.editableItem.hireddate) ||
                Utils.isValidDate(this.editableItem.hireddate);
            this.isValidTerminateDate =
                this.isReadOnlyTerminateDate ||
                Utils.isNullOrEmptyString(this.editableItem.terminatedate) ||
                Utils.isValidDate(this.editableItem.terminatedate);
            this.isEmployeeTypeValid = !Utils.isNullOrEmptyString(this.editableItem.emptype);
            this.isNeedCosignerValid = !Utils.isNullOrEmptyString(this.editableItem.needCoSigner);
            this.isEmployeeFirstNameValid = !Utils.isNullOrEmptyString(this.editableItem.firstname);
            this.isEmployeeLastNameValid = !Utils.isNullOrEmptyString(this.editableItem.lastname);

            return (
                this.isValidDob &&
                this.isValidHiredDate &&
                this.isValidTerminateDate &&
                this.isEmployeeTypeValid &&
                this.isNeedCosignerValid &&
                this.isEmployeeFirstNameValid &&
                this.isEmployeeLastNameValid
            );
        },

        validate_entries() {
            this.emailValid =
                this.editableItem.eMail == '' || this.editableItem.eMail == null ? true : false;

            this.emailValid =
                Utils.isNullOrEmptyString(this.editableItem.eMail) ||
                validator.isEmail(this.editableItem.eMail);

            return this.emailValid;
        },

        onRowSelectedDocument() {},

        onRowSelectedDocumentMgr() {},

        onRowSelectedPharmacyRemoval() {},

        onRowSelectedPharmacy() {},

        onRowSelectedBuilding() {},

        onRowSelectedProgram() {},

        onFilteredBuilding() {},

        onFilteredProgram() {},

        onFilteredPharmacy() {},

        onFilteredPharmacyRemoval() {},

        onFilteredDocument() {},

        onFilteredDocumentMgr() {},

        pageChangedProgram(value) {
            this.perPageProgram = value;
        },

        pageChangedBuilding(value) {
            this.perPageBuilding = value;
        },

        pageChangedPharmacy(value) {
            this.perPagePharmacy = value;
        },

        pageChangedDocument(value) {
            this.perPageDocument = value;
        },

        pageChangedDocumentMgr(value) {
            this.perPageDocumentMgr = value;
        },

        PerPageFunctionDocument(value) {
            this.perPageDocument = value;

            if (this.currentPageDocument > this.totalRowsDocument / this.perPageDocument) {
                this.currentPageDocument = 1;
            }
        },

        PerPageFunctionDocumentMgr(value) {
            this.perPageDocumentMgr = value;

            if (this.currentPageDocumentMgr > this.totalRowsDocumentMgr / this.perPageDocumentMgr) {
                this.currentPageDocumentMgr = 1;
            }
        },

        PerPageFunctionBuilding(value) {
            this.perPageBuilding = value;

            if (this.currentPageBuilding > this.totalRowsBuilding / this.perPageBuilding) {
                this.currentPageBuilding = 1;
            }
        },

        PerPageFunctionProgram(value) {
            this.perPageProgram = value;

            if (this.currentPageProgram > this.totalRowsProgram / this.perPageProgram) {
                this.currentPageProgram = 1;
            }
        },

        pageChangedPharmacyRemoval(value) {
            this.perPagePharmacyRemoval = value;

            if (
                this.currentPagePharmacyRemoval >
                this.totalRowsPharmacyRemoval / this.PerPageFunctionPharmacyRemoval
            ) {
                this.currentPagePharmacyRemoval = 1;
            }
        },

        PerPageFunctionPharmacyRemoval(value) {
            this.perPagePharmacyRemoval = value;

            if (
                this.currentPagePharmacyRemoval >
                this.totalRowsPharmacyRemoval / this.perPagePharmacyRemoval
            ) {
                this.currentPagePharmacyRemoval = 1;
            }
        },

        PerPageFunctionPharmacy(value) {
            this.perPagePharmacy = value;

            if (this.currentPagePharmacy > this.totalRowsPharmacy / this.perPagePharmacy) {
                this.currentPagePharmacy = 1;
            }
        },

        FindDocument() {
            this.search.document = this.searchDocument;
            this.currentPageDocument = 1;
        },

        FindDocumentMgr() {
            this.search.documentMgr = this.searchDocumentMgr;
            this.currentPageDocumentMgr = 1;
        },

        FindBuilding() {
            this.search.building = this.searchBuilding;
            this.currentPageBuilding = 1;
        },

        FindProgram() {
            this.search.program = this.searchProgram;
            this.currentPageProgram = 1;
        },

        FindPharmacyRemoval() {
            this.search.pharmacyRemoval = this.searchPharmacyRemoval;
            this.currentPagePharmacyRemoval = 1;
        },

        FindPharmacy() {
            this.search.pharmacy = this.searchPharmacy;
            this.currentPagePharmacy = 1;
        },

        CallModalDocument() {
            this.editableDocument = {
                employeeCode: '',
                docCode: '',
                recNo: null,
                comment: '',
                expDate: null,
                documentName: ''
            };
            this.editableItemMode = false;
            this.visibleDocumentModal = true;
        },

        CallModalDocumentMgr() {
            this.editableDocumentMgr = {
                comments: '',
                description: '',
                doccode: '',
                entitycode: '',
                entitytype: '',
                expirationDate: null,
                extension: '',
                fileName: '',
                scanneddate: null,
                seqno: null,
                sysUser: null,
                IsNew: false,
                Image: ''
            };
            this.editableItemMode = false;
            this.visibleDocumentMgrModal = true;
        },

        CallModalBuilding() {
            this.$bvModal.show(this.BuildingDlgId);
        },

        CallModalProgram() {
            this.$bvModal.show(this.ProgramDlgId);
        },

        CallModalPharmacyRemoval() {
            this.PharmacyModalType = 'Removal';
            this.$bvModal.show(this.PharmacyDlgId);
        },

        CallModalPharmacy() {
            this.PharmacyModalType = 'Pharmacy';
            this.$bvModal.show(this.PharmacyDlgId);
        },

        EditDocument(value) {
            this.editableItemMode = true;
            this.editableDocument = value;
            this.visibleDocumentModal = true;
        },

        EditDocumentMgr(value) {
            this.editableItemMode = true;
            this.editableDocumentMgr = value;
            this.visibleDocumentMgrModal = true;
        },

        saveDocument(value) {
            if (!this.editableItemMode) {
                this.editableItem.documentCodesList.push(value);
                this.emitChanged('document');
            } else {
                const index = this.editableItem.documentCodesList.findIndex(
                    item => item === this.editableDocument
                );

                if (index !== -1) {
                    this.$set(this.editableItem.documentCodesList, index, value);
                    this.emitChanged('document');
                }
            }
        },

        saveDocumentMgr(value) {
            if (!this.editableItemMode) {
                this.editableItem.documentMgrCodesList.push(...value);
            } else {
                const index = this.editableItem.documentMgrCodesList.findIndex(
                    item => item.seqno === this.editableDocumentMgr.seqno
                );

                if (index !== -1) {
                    this.editableItem.documentMgrCodesList.splice(index, 1);
                }

                const insertIndex =
                    index !== -1 ? index : this.editableItem.documentMgrCodesList.length;
                this.editableItem.documentMgrCodesList.splice(insertIndex, 0, ...value);
            }

            this.emitChanged('documentMgr');
        },

        RemoveDocument(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_document'
                })
                .then(value => {
                    if (value) {
                        const index = this.editableItem.documentCodesList.findIndex(
                            item => item === itemToRemove
                        );

                        if (index !== -1) {
                            this.editableItem.documentCodesList.splice(index, 1);
                            this.emitChanged('document');

                            if (
                                this.currentPageDocument >
                                this.totalRowsDocument / this.perPageDocument
                            ) {
                                this.currentPageDocument--;
                            }
                        }
                    }
                });
        },

        RemoveDocumentMgr(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_document'
                })
                .then(value => {
                    if (value) {
                        const index = this.editableItem.documentMgrCodesList.findIndex(
                            item => item === itemToRemove
                        );

                        if (index !== -1) {
                            this.editableItem.documentMgrCodesList.splice(index, 1);
                            this.emitChanged('documentMgr');

                            if (
                                this.currentPageDocumentMgr >
                                this.totalRowsDocumentMgr / this.perPageDocumentMgr
                            ) {
                                this.currentPageDocumentMgr--;
                            }
                        }
                    }
                });
        },

        RemoveBuilding(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.buildingCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.buildingCodesList.splice(index, 1);
                                this.emitChanged('building');

                                if (
                                    this.currentPageBuilding >
                                    this.totalRowsBuilding / this.perPageBuilding
                                ) {
                                    this.currentPageBuilding--;
                                }
                            }
                        }
                    }
                });
        },

        RemoveProgram(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.programCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.programCodesList.splice(index, 1);
                                this.emitChanged('program');

                                if (
                                    this.currentPageProgram >
                                    this.totalRowsProgram / this.perPageProgram
                                ) {
                                    this.currentPageProgram--;
                                }
                            }
                        }
                    }
                });
        },

        RemovePharmacy(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.pharmacyCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.pharmacyCodesList.splice(index, 1);
                                this.emitChanged('pharmacy');

                                if (
                                    this.currentPagePharmacy >
                                    this.totalRowsPharmacy / this.perPagePharmacy
                                ) {
                                    this.currentPagePharmacy--;
                                }
                            }
                        }
                    }
                });
        },

        RemovePharmacyRemoval(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.pharmacyRemovalCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.pharmacyRemovalCodesList.splice(index, 1);
                                this.emitChanged('pharmacyRemoval');

                                if (
                                    this.currentPagePharmacyRemoval >
                                    this.totalRowsPharmacyRemoval /
                                        this.PerPageFunctionPharmacyRemoval
                                ) {
                                    this.currentPagePharmacyRemoval--;
                                }
                            }
                        }
                    }
                });
        },

        async getSignaturePad() {
            let param = {
                CodeType: 'SignaturePad',
                OrderBy: 'Description'
            };
            await GlobalService.getGlobalCustom(param)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.signaturePadList = response.data.map(value => ({
                            code: value.value,
                            description: value.description
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getInsurances() {
            await InsuranceService.getAllInsurances({})
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.insuranceList = response.data.map(value => ({
                            code: value.insurancecode,
                            description: value.company
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getDocumentType() {
            await DocumentTypeService.getAll({})
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.documentTypeList = response.data.map(value => ({
                            code: value.code,
                            description: value.description
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        emitChanged(componentName) {
            const changed = {
                Changed: true,
                ComponentName: componentName
            };

            EventBus.$emit('onChanged', changed);
        },

        async initializeData() {
            try {
                await Promise.allSettled([
                    this.getDefaultDateTime(),
                    this.getEmployeeTypes(),
                    this.getCellPhoneCompany(),
                    this.getBranchLocation(),
                    this.getRaces(),
                    this.getCredential(),
                    this.getSignaturePad(),
                    this.getInsurances(),
                    this.getDocumentType()
                ]).then(() => {
                    this.getEmployee().then(() => this.setupEventListeners());
                });
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        setupEventListeners() {
            EventBus.$on('onChanged', e => {
                if (this.loaded && !this.isReadOnly) {
                    this.pendingChanges = e.Changed;
                    this.checkUserAction();
                }
            });

            window.addEventListener('beforeunload', this.beforeWindowUnload);

            EventBus.$on('onMouseStop', data => {
                const { img, ext } = Utils.parseBase64Image(data.Image);

                switch (data.Id) {
                    case 'IdCanvasSignatureEmployee':
                        this.editableItem.employeesignature = img;
                        this.editableItem.employeesignatureExt = ext;
                        break;

                    case 'IdCanvasSignatureEmployeeempstamp':
                        this.editableItem.employeestamp = img;
                        this.editableItem.employeestampExt = ext;
                        break;
                }

                this.emitChanged(data.Id);
            });
        },

        cleanupEventListeners() {
            EventBus.$off('onChanged');
            window.removeEventListener('beforeunload', this.beforeWindowUnload);
            EventBus.$off('onMouseStop');
        }
    },

    created() {
        this.initializeData();
    },

    beforeDestroy() {
        this.cleanupEventListeners();
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_Employee');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.pageTitle,
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    }
};
</script>
